// ui/CalendarSkeleton.jsx

import React from "react";

export default function CalendarSkeleton() {
  return (
    <div className="overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white dark:border-white/10 dark:bg-slate-900">
      <div className="grid grid-cols-7 gap-px bg-slate-200 dark:bg-white/10">
        {Array.from({ length: 7 }, (_, index) => (
          <div
            key={`header-${index}`}
            className="h-11 animate-pulse bg-slate-800 dark:bg-slate-950"
          />
        ))}
      </div>

      <div className="grid grid-cols-7 gap-px bg-slate-200 dark:bg-white/10">
        {Array.from({ length: 42 }, (_, index) => (
          <div
            key={`cell-${index}`}
            className="min-h-[142px] bg-white p-3 dark:bg-slate-900"
          >
            <div className="h-6 w-6 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />

            {index % 3 === 0 && (
              <div className="mt-5 h-12 animate-pulse rounded-lg bg-slate-100 dark:bg-white/5" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}